"use strict";

import { onWindowWidthChange } from "./helper-functions.js";


function initTeamSlider() {

	// Initial settings
	var outer_div = document.getElementById("team-slider-outer");
	var button_prev = document.getElementsByClassName("team-slider-prev")[0];
	var button_next = document.getElementsByClassName("team-slider-next")[0];
	var slides = outer_div.querySelectorAll("aside");
	var slides_visible = parseFloat( getComputedStyle(outer_div).getPropertyValue("--slides-visible") );
	var slider_timer;
	var current_slide = parseFloat( getComputedStyle(outer_div).getPropertyValue("--current-slide") );
	var resize_buffer;


	// Functions
	function slide(direction) {
		if (direction === "prev" && current_slide > 0) {
			current_slide--;
			outer_div.style.setProperty("--current-slide", current_slide);
		} else if (direction === "next" && current_slide < slides.length - slides_visible) {
			current_slide++;
			outer_div.style.setProperty("--current-slide", current_slide);
		}
	}


	// Interation
	button_prev.addEventListener("click", function() {
		stopTimer();
		slide("prev");
		startTimer();
	});
	button_next.addEventListener("click", function() {
		stopTimer();
		slide("next");
		startTimer();
	});


	// Timer
	function startTimer() {
		slider_timer = setInterval(function(){
			slide("next");
		}, 10000);
	}
	startTimer();

	function stopTimer() {
		clearInterval(slider_timer);
	}


	function resizeTasks() {
		clearTimeout(resize_buffer);
		stopTimer();
		resize_buffer = setTimeout(resizeBufferTasks, 500);
	}

	function resizeBufferTasks() {
		// Mobile devices trigger onresize when the browser's navbar dissapears & reapears (triggered by scrolling)
		var new_slides_visible = parseFloat( getComputedStyle(outer_div).getPropertyValue("--slides-visible") );

		if (new_slides_visible > slides_visible && current_slide >= slides.length - slides_visible) {
			// Increasing the width of the slider when it's reached the last slide will allow the new slide spot to be empty.
			// Ensure slide width has changed before triggering
			slide("prev");
		}

		slides_visible = new_slides_visible;

		startTimer();
	}

	onWindowWidthChange(resizeTasks);
}


window.addEventListener("pageshow", initTeamSlider);
